/** «Κάθε μέρα» ή «Δευ, Τετ, Παρ». Κοινό για κάρτα και καρτέλα προμηθευτή. */
export function describeDeliveryDays(
  days: number[],
  t: (key: string) => string,
  short = false,
): string {
  if (days.length === 0) return t('delivery.everyDay')
  return days.map((d) => t(`${short ? 'weekdaysShort' : 'weekdays'}.${d}`)).join(', ')
}
